<template>
  <div>
    <div v-if="isEditMode">
      <div class="d-flex flex-wrap">
        <h4 class="d-inline">Подтверждение участия</h4>
        <b-button
          v-if="!voting"
          @click="addVoting"
          variant="outline-primary"
          class="ml-auto mb-3 float-right"
        ><em class="fa fa-plus mr-1"></em> Добавить голосование</b-button>
        <div v-else class="ml-auto">
          <b-button
            variant="outline-primary"
            v-b-modal.modalChangeVotingSettings
          ><em class="fas fa-edit mr-1"></em> Редактировать</b-button>
          <b-button
            variant="outline-primary" class="ml-2" @click="deleteVoting"
          > <em class="fas fa-times-circle"></em> Удалить</b-button>
        </div>
      </div>
      <div v-if="voting" class="text-center mt-2">
        <b-button variant="primary" disabled title="Кнопка доступна в режиме просмотра">
          Подтвердить участие
        </b-button>
      </div>
      <b-alert v-else show variant="info">Голосование отсутствует</b-alert>
    </div>
    <div v-else-if="voting">
      <div class="text-center">
        <b-button
          @click="openAcceptVotingModal"
          variant="primary"
          v-if="!isUserMember">
          Подтвердить участие
        </b-button>
        <b-button
          v-b-modal.modalCheckVoting
          variant="outline-primary"
          v-else>
          Информация об участии
        </b-button>
        <b-button
          variant="primary"
          class="ml-1"
          @click="exportVotingResults"
          v-if="content.contentObject.status === 'опубликовано'
            && (hasRole('curator') || hasRole('admin') || hasRole('classroom-teacher'))">
          <em class="fas fa-file-excel mr-1"></em> Экспорт результатов
        </b-button>
      </div>
    </div>
    <b-modal
      hide-footer
      id="modalChangeVotingSettings"
      title="Настройки подтверждения участия"
      @hidden="onReset"
      header-bg-variant="primary"
      header-text-variant="light"
    >
      <b-form @submit="onSubmit" @reset="onReset">
        <b-form-radio-group
          label="Тип голосования"
          v-model="withSettings"
          :options="optionsSetting">
        </b-form-radio-group>
        <div v-if="withSettings">
          <hr />
          <b-form-checkbox
            v-model="withTimeParams"
          >
            Выбор даты и/или времени
          </b-form-checkbox>
          <div v-if="withTimeParams && isInputReady">
            <b-form-radio-group
              class="mt-1"
              v-model="timeParamsType"
              @change="onChangeTimeParamsType"
              :options="optionsTimeSetting">
            </b-form-radio-group>
            <div>
              <b-input-group
                v-for="(param, index) in voting.settings[timeParamsType]"
                :key="index"
                class="mb-2"
              >
                <b-input
                  :type="timeParamsType === 'datetime' ? 'datetime-local' : timeParamsType"
                  v-model="voting.settings[timeParamsType][index]"
                  disabled></b-input>
                <b-input-group-append>
                  <b-button variant="primary" @click="deleteParamsVariant(timeParamsType, index)">
                    <em class="fas fa-times-circle"></em>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
              <b-input
                :type="timeParamsType === 'datetime' ? 'datetime-local' : timeParamsType"
                class="mb-2"
                v-model="changedTimeVariant"
              ></b-input>
              <b-button
                variant="outline-primary"
                @click="addTimeVariant(timeParamsType)"
                :disabled="!changedTimeVariant">
                <em class="fa fa-plus mr-1"></em> Добавить
              </b-button>
            </div>
            <hr />
          </div>
          <b-form-checkbox
            v-model="withTextParams"
          >
            Дополнительные текстовые поля
          </b-form-checkbox>
          <div v-if="withTextParams && isInputReady">
            <b-input-group
              v-for="(field, index) in voting.settings.fieldsDefault"
              :key="`default-${index}`"
              class="mb-2">
            <b-input
              v-model="voting.settings.fieldsDefault[index]"
              disabled />
              <b-input-group-append>
                <b-button
                  variant="primary"
                  v-b-tooltip.hover
                  title="Данное поле будет заполнено автоматически и не будет отображаться при записи"
                >
                  <em class="fas fa-info"></em>
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <b-input-group
              v-for="(field, index) in voting.settings.fieldsNew"
              :key="`additional-${index}`"
              class="mb-2">
              <b-input
                v-model="voting.settings.fieldsNew[index]"
                disabled></b-input>
              <b-input-group-append>
                <b-button variant="primary" @click="deleteParamsVariant('fieldsNew', index)">
                  <em class="fas fa-times-circle"></em>
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <b-input
              class="mb-2"
              placeholder="Введите название поля"
              v-model="changedInfoVariant"
            ></b-input>
            <b-button
              variant="outline-primary"
              @click="addInfoVariant"
              :disabled="!changedInfoVariant">
              <em class="fa fa-plus mr-1"></em> Добавить
            </b-button>
          </div>
        </div>
        <div class="text-right">
          <b-button type="submit" variant="primary">Сохранить</b-button>
          <b-button type="reset" class="ml-2" variant="outline-primary">Отмена</b-button>
        </div>
      </b-form>
    </b-modal>
    <b-modal
      v-if="voting"
      hide-footer
      id="modalCheckVoting"
      header-bg-variant="primary"
      header-text-variant="light"
      :title="isUserMember ? 'Информация об участии' : 'Подтверждение участия'">

      <div v-if="Object.keys(voting.settings).length === 1">
        Вы подтвердили участие!
      </div>
      <div v-else>
        <div>
          <div
            v-for="(field, index) in optionsTimeSetting
              .map(o => o.value).filter(key =>voting.settings[key])"
            class="mb-2"
            :key="index"
          >
          <div>{{ optionsTimeSetting.find(o => o.value === field).text }}</div>
          <b-form-select
            :key="field"
            :disabled="isUserMember"
            v-model="userMember[field]"
            :options="voting.settings[field]
              .map(variant => ({
                text: castTextForSettings(variant, field),
                value: variant
              }))"
          />
          </div>
        </div>
        <div v-if="voting.settings.fieldsNew">
          <div
            class="mb-2"
            :key="index"
            v-for="(field, index) of voting.settings.fieldsNew"
          >
            <div>{{ field }}</div>
            <b-input
              class="mb-2"
              :disabled="isUserMember"
              v-model="userMember[field]"
            ></b-input>
          </div>
        </div>
        <div class="text-center" v-if="!isUserMember">
          <b-button
            variant="primary"
            @click="sendAccept"
            :disabled="isAcceptDisabled"
          >Подтвердить</b-button>
        </div>
      </div>
    </b-modal>
    <b-modal
      header-bg-variant="primary"
      header-text-variant="light"
      id="modalConfirmSaveVoting"
      hide-footer
      title="Сохранение формы подтверждения">
      <p class="my-1">
        У Вас остались несохраненные значения. Нажмите
        <strong> Продолжить</strong>, чтобы проигнорировать их.
      </p>
      <p>
        Значения добавляются после нажатия на кнопку <strong>Добавить</strong>.
      </p>
      <div class="mt-4 d-flex justify-content-end">
        <b-button variant="primary" @click="onConfirmSavingVoting">
          Продолжить
        </b-button>
        <b-button
          class="ml-1"
          variant="outline-primary"
          @click="$bvModal.hide('modalConfirmSaveVoting')"
        >
          Отмена
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
import ContentApi from '@/api/content'

export default {
  name: 'VotingParticipation',
  computed: {
    ...mapGetters({
      content: 'content/getContent',
      hasRole: 'currentUser/hasRole',
      currUser: 'currentUser/getCurrentUser',
      isEditMode: 'contentManager/isEditMode'
    }),
    isAcceptDisabled() {
      let disable = false
      if (this.voting) {
        if (_.isArray(this.voting.settings.fieldsNew)) {
          for (const field of this.voting.settings.fieldsNew) {
            if (!this.userMember[field]) {
              disable = true
            }
          }
        }
        for (const field of this.optionsTimeSetting.map((o) => o.value)) {
          if (_.isArray(this.voting.settings[field]) && !this.userMember[field]) {
            disable = true
          }
        }
      }
      return disable
    }
  },
  data() {
    return {
      voting: null,
      userMember: {},
      isUserMember: false,
      withSettings: false,
      isInputReady: true,
      withTimeParams: false,
      timeParamsType: 'time',
      withTextParams: false,
      changedTimeVariant: '',
      changedInfoVariant: '',
      optionsSetting: [
        { text: 'С параметрами', value: true },
        { text: 'Простое подтверждение', value: false }
      ],
      optionsTimeSetting: [
        { text: 'Время', value: 'time' },
        { text: 'Дата', value: 'date' },
        { text: 'Дата и время', value: 'datetime' }
      ]
    }
  },
  created() {
    this.voting = this.content.contentObject.votingSettings
      ? _.cloneDeep(this.content.contentObject.votingSettings.participant)
      : null
    this.userMember = this.content.contentObject.userParticipant
      && _.cloneDeep(this.content.contentObject.userParticipant.voteData) || {}
    this.isUserMember = !!Object.keys(this.userMember).length
    this.updateClientSettings()
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault()
      if (!this.withSettings) {
        this.voting = this.getEmptyVoting()
        this.onConfirmSavingVoting()
      } else {
        if (!this.withTextParams) {
          delete this.voting.settings.fieldsNew
        }
        const timeKeys = this.optionsTimeSetting.map((o) => o.value)
        for (const key of timeKeys) {
          if (!this.withTimeParams || key !== this.timeParamsType) {
            delete this.voting.settings[key]
          }
        }
        if (this.changedInfoVariant || this.changedTimeVariant) {
          this.$bvModal.show('modalConfirmSaveVoting')
        } else {
          this.onConfirmSavingVoting()
        }
      }
    },
    onConfirmSavingVoting() {
      this.changedInfoVariant = ''
      this.changedTimeVariant = ''
      this.updateClientSettings()
      this.updateUpdater(this.updater + 1)
      this.updateEventSettings(this.voting)
      this.updateContentSavedStatus(false)
      this.$bvModal.hide('modalChangeVotingSettings')
      this.$bvModal.hide('modalConfirmSaveVoting')
    },
    onReset(evt) {
      evt.preventDefault()
      this.voting = this.content.contentObject.votingSettings
        ? _.cloneDeep(this.content.contentObject.votingSettings.participant)
        : null
      this.updateClientSettings()
      this.$bvModal.hide('modalChangeVotingSettings')
    },
    updateClientSettings() {
      this.withSettings = !!(this.voting && Object.keys(this.voting.settings).length > 1)
      this.withTimeParams = this.withSettings && !!(this.voting.settings.time
        || this.voting.settings.date || this.voting.settings.datetime)
      this.withTextParams = this.withSettings && !_.isEmpty(this.voting.settings.fieldsNew)
      if (this.withTimeParams) {
        this.timeParamsType = this.voting.settings.time ? 'time' : (this.voting.settings.date ? 'date' : 'datetime')
      }
    },
    deleteParamsVariant(field, index) {
      this.isInputReady = false
      this.voting.settings[field].splice(index, 1)
      this.isInputReady = true
    },
    addTimeVariant(field) {
      if (_.isArray(this.voting.settings[field])) {
        this.voting.settings[field].push(this.changedTimeVariant)
      } else {
        this.voting.settings[field] = [this.changedTimeVariant]
      }
      this.changedTimeVariant = ''
    },
    addInfoVariant() {
      if (_.isArray(this.voting.settings.fieldsNew)) {
        this.voting.settings.fieldsNew.push(this.changedInfoVariant)
      } else {
        this.voting.settings.fieldsNew = [this.changedInfoVariant]
      }
      this.changedInfoVariant = ''
    },
    onChangeTimeParamsType() {
      this.changedTimeVariant = ''
    },
    openAcceptVotingModal() {
      if (Object.keys(this.voting.settings).length === 1) {
        this.sendAccept()
      }
      this.$bvModal.show('modalCheckVoting')
    },
    async sendAccept() {
      const userFIO = this.currUser.midname
        ? `${this.currUser.surname} ${this.currUser.name} ${this.currUser.midname}`
        : `${this.currUser.surname} ${this.currUser.name}`
      this.userMember = {
        ...this.userMember,
        ФИО: userFIO,
        Почта: this.currUser.email,
        'Класс/Организация': this.currUser.organizationId
      }
      if (this.content.contentObject.status === 'опубликовано') {
        try {
          await ContentApi.addVoteParticipantOnEvent(this.content.contentObject.id, this.userMember)
          this.isUserMember = !!Object.keys(this.userMember).length
        } catch {
          this.pushToasts({
            title: 'Ошибка',
            error: true,
            message: 'Во время подтверждения участия произошла ошибка.',
            time: 5
          })
        }
      } else {
        this.pushToasts({
          title: 'Уведомление',
          error: true,
          message: 'Подтверждение участия не было выполнено, т.к. данное мероприятие не опубликовано.',
          time: 5
        })
      }
      this.$bvModal.hide('modalCheckVoting')
    },
    addVoting() {
      this.voting = this.getEmptyVoting()
      this.updateUpdater(this.updater + 1)
      this.updateEventSettings(this.voting)
      this.updateContentSavedStatus(false)
    },
    deleteVoting() {
      this.withTimeParams = false
      this.withTextParams = false
      this.withSettings = false
      this.voting = null
      this.isUserMember = false
      this.userMember = {}
      this.updateUpdater(this.updater + 1)
      this.updateEventSettings(this.voting)
      this.updateContentSavedStatus(false)
    },
    castTextForSettings(value, type) {
      if (type === 'date') {
        return moment(value).format('DD.MM.YYYY')
      } if (type === 'datetime') {
        return moment(value).format('DD.MM.YYYY HH:mm')
      }
      return value
    },
    getEmptyVoting() {
      return {
        settings: {
          fieldsDefault: ['ФИО', 'Почта', 'Класс/Организация']
        }
      }
    },
    exportVotingResults() {
      if (this.content.contentObject.id) {
        ContentApi.exportVotingParticipantExcel(this.content.contentObject)
      }
    },
    ...mapMutations({
      updateContentSavedStatus: 'contentManager/updateContentSavedStatus'
    }),
    ...mapActions({
      updateUpdater: 'contentManager/updateUpdater',
      pushToasts: 'toasts/pushToasts',
      updateEventSettings: 'contentManager/updateEventSettings'
    })
  }
}
</script>

<style scoped>

</style>
